export default "__VITE_ASSET__CEAtA38P__"